export default __webpack_public_path__ + "static/media/chaithanya.0c27e992.jpeg";